import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { Banknote, CalendarX, Frown } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

const stats = [
  {
    icon: Banknote,
    value: "10 Mds €",
    label: "d'aides non réclamées par an",
  },
  {
    icon: CalendarX,
    value: "1 sur 3",
    label: "a déjà raté une deadline admin",
  },
  {
    icon: Frown,
    value: "#2",
    label: "facteur de stress chez les jeunes",
  }
];

export const ProblemSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  const { isDark } = useTheme();

  return (
    <section 
      id="problem"
      className={`section-apple px-6 ${isDark ? 'bg-black' : 'bg-[#f5f5f7]'}`}
      data-testid="problem-section"
    >
      <div className="max-w-[980px] mx-auto">
        {/* Headline */}
        <motion.div
          ref={ref}
          className="text-center mb-20"
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }}
        >
          <h2 className={`text-[40px] sm:text-[48px] md:text-[56px] font-semibold tracking-[-0.03em] leading-[1.1] mb-6 ${
            isDark ? 'text-[#f5f5f7]' : 'text-[#1d1d1f]'
          }`}>
            <span className="text-[#FF6B6B]">67%</span> des jeunes<br />
            perdent de l'argent.
          </h2>
          <p className={`text-[19px] sm:text-[21px] tracking-[-0.016em] ${
            isDark ? 'text-[#86868b]' : 'text-[#6e6e73]'
          }`}>
            L'administratif est complexe. On simplifie tout ça.
          </p>
        </motion.div>

        {/* Stats grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-4">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              className="text-center"
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: 0.2 + index * 0.1, ease: [0.25, 0.1, 0.25, 1] }}
            >
              {/* Icon - thin, no background */}
              <stat.icon 
                size={32} 
                strokeWidth={1} 
                className={`mx-auto mb-4 ${isDark ? 'text-[#86868b]' : 'text-[#6e6e73]'}`}
              />
              
              {/* Value */}
              <p className="text-[40px] sm:text-[48px] font-semibold tracking-[-0.02em] text-[#81d8d0] mb-2">
                {stat.value}
              </p>
              
              {/* Label */}
              <p className={`text-[15px] tracking-[-0.01em] ${
                isDark ? 'text-[#6e6e73]' : 'text-[#86868b]'
              }`}>
                {stat.label}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Transition text */}
        <motion.p
          className={`text-center text-[21px] sm:text-[24px] tracking-[-0.016em] mt-20 ${
            isDark ? 'text-[#86868b]' : 'text-[#6e6e73]'
          }`}
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.6 }}
        >
          Et si une app faisait <span className="text-[#81d8d0]">tout ça pour toi</span> ?
        </motion.p>
      </div>
    </section>
  );
};

export default ProblemSection;
